// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gv-0";